<ion-grid>
  <ion-row class="ion-justify-content-center">
    <ion-col>
      <div class="calendar-label">{{ this.getLabel() }}</div>
    </ion-col>
  </ion-row>
  <ion-row class="calendar-day-names">
    <ion-col>
      Sun
    </ion-col>
    <ion-col>
      Mon
    </ion-col>
    <ion-col>
      Tue
    </ion-col>
    <ion-col>
      Wed
    </ion-col>
    <ion-col>
      Thr
    </ion-col>
    <ion-col>
      Fri
    </ion-col>
    <ion-col>
      Sat
    </ion-col>
  </ion-row>

  <ion-row *ngFor="let week of weeks; trackBy: trackByWeek">
    <ion-col class="calendar-col" *ngFor="let day of week; trackBy: trackByDay">
      <div class="day-cell" [ngClass]="{'day-booked': day.hasBooking(), 'day-available': day.date && !day.hasBooking()}" (click)="onSelect(day)" [id]="day.date">
        <div class="day-number">{{ day.getDay() }}</div>
        <div class="day-initials" *ngIf="day.hasBooking()">{{ day.info.initials }}</div>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
